import Model  from '@/util/models';

export default class Dapil extends Model { 
    backend = '/frc/dapil/'; 
    
    
    
    tingkats(){       
      return this.api.get(this.backend + 'tingkats').then(res => {
        return res.status === 200 ? res.data : [];
      })
    }  
    
    areas(params){
      return this.api.get(this.backend + 'areas',params).then(res => {
        return res.status === 200 ? res.data : [];
      })
    }
    
    kompetisis(params){
      return this.api.get(this.backend + 'kompetisis',params).then(res => {
        return res.status === 200 ? res.data : [];
      })
    }
}

